import { useEffect, useReducer, useRef } from 'react';
import useCompare from './useCompare';

const initialState = {
  isFetching: false,
  filter: {},
  data: null,
  totalItems: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_INIT':
      return { ...state, isFetching: true };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        totalItems: action.payload.totalItems,
      };
    case 'FILTER':
      return {
        ...initialState,
        filter: action.payload.filter,
        data: action.payload.initialData,
        totalItems: action.payload.totalItems,
      };
    default:
      throw new Error();
  }
};

export default (
  provider,
  param,
  requestOnMount,
  initialData,
  errorHandler = () => {},
  successCallback = () => {}
) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    data: initialData,
  });
  const diff = useCompare(param);
  const diffProvider = useCompare(provider);
  const shouldLoad = useRef(requestOnMount);

  const { filter } = state;

  useEffect(() => {
    if (diff || diffProvider) {
      dispatch({ type: 'FETCH_SUCCESS', payload: { data: initialData } });
    } else if (shouldLoad.current) {
      dispatch({ type: 'FETCH_INIT' });
      provider(param, filter)
        .then(result => {
          dispatch({
            type: 'FETCH_SUCCESS',
            payload: {
              data: result.ok ? result?.data : initialData,
              totalItems: result.headers
                ? +result.headers['x-total-count']
                : null,
            },
          });
          shouldLoad.current = false;
          if (result.ok) {
            successCallback && successCallback(result);
          } else if (!result.ok) {
            errorHandler && errorHandler(result);
          }
        })
        .catch(err => errorHandler && errorHandler(err));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diff, diffProvider, filter, provider, shouldLoad.current]);

  function fetchFilter(payload) {
    shouldLoad.current = true;
    dispatch({
      type: 'FILTER',
      payload: {
        filter:
          typeof payload === 'string' || typeof payload === 'number'
            ? payload
            : { ...payload },
        initialData,
      },
    });
  }

  return [state, fetchFilter];
};
